/**
 * Override popup styles for web platforms.
 * Adds CSS styles to the document head to override MapLibre popup styles.
 */
export function overridePopupStyles(): void {
  if (typeof document === 'undefined') return;

  // Check if style already exists
  if (document.querySelector('#sg-map-popup-styles-override')) return;

  const style = document.createElement('style');
  style.id = 'sg-map-popup-styles-override';
  style.textContent = `
    .maplibregl-popup-content {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
    }
    .maplibregl-popup-tip {
      display: none !important;
    }
  `;
  document.head.append(style);
}
